export const makeComment = ({ id, userId, planItemId, body, createdAt }) => ({
  id,
  userId,
  planItemId,
  body,
  createdAt,
})
